/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Sidebar_Email_LabelInputs */

const en_directory_sidebar_email_label = /** @type {(inputs: Directory_Sidebar_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const zh_directory_sidebar_email_label = /** @type {(inputs: Directory_Sidebar_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Directory_Sidebar_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_sidebar_email_label = /** @type {((inputs?: Directory_Sidebar_Email_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Sidebar_Email_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_sidebar_email_label(inputs)
	return zh_directory_sidebar_email_label(inputs)
});
export { directory_sidebar_email_label as "directory.sidebar.email_label" }